import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataSharingService {
    public isDisplay: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public EnergymeterMasterId: BehaviorSubject<number> = new BehaviorSubject<number>(0);

    public DashboardData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
}
